export default "__VITE_ASSET__CIp9AIgc__"